import cx from 'clsx';

import { VENDORS_ROUTER } from '~/constants/router';
import ShoppingCartButton from '~/domains/cart/ShoppingCartButton';
import ProductPrice from '~/domains/products/components/ProductPrice';
import ProductImage from '~/domains/products/ProductImage';
import { useTrackProductEventProps } from '~/hooks/event';
import { useLinkComponent } from '~/hooks/mobileApp';
import type { OAISchema } from '~/types/openapi';

type Props = {
  item: OAISchema['MarketSelectProductResponseV2'];
  eventOption?: Record<string, unknown>;
  className?: string;
  reverseCouponDiscountedPrice?: boolean;
};

const EventProductButtonCartCard = ({
  item,
  eventOption,
  className,
  reverseCouponDiscountedPrice = false,
}: Props) => {
  const LinkComponent = useLinkComponent();
  const [props, { trackAddCart }] = useTrackProductEventProps(
    item,
    eventOption,
  );
  const { vendorId, offerId, mainImages, isOutOfStock, productName, status } =
    item;

  return (
    <LinkComponent href={VENDORS_ROUTER.productDetail(vendorId, offerId!)}>
      <div
        role="presentation"
        {...props}
        className={cx([
          'rounded-12 border border-gray-200 bg-gray-000 overflow-hidden',
          className,
        ])}
      >
        <ProductImage
          layout="fill"
          src={mainImages![0]}
          alt={productName}
          isOutOfStock={isOutOfStock}
          status={status}
          className="!border-none"
        />
        <div className="px-8 py-12 pt-6">
          <div className="min-h-[60px]">
            <p
              className="mb-4 line-clamp-2 whitespace-pre-line leading-[18px] text-normal"
              style={{ fontSize: '14px' }}
            >
              {productName}
            </p>
            <ProductPrice {...item} reverse={reverseCouponDiscountedPrice} />
          </div>
          <ShoppingCartButton
            item={item}
            className="mt-8 rounded-12 !bg-primary-regular py-[5px] text-gray-100 typo-paragraph100-semibold"
            onClick={trackAddCart}
          >
            장바구니 담기
          </ShoppingCartButton>
        </div>
      </div>
    </LinkComponent>
  );
};

export default EventProductButtonCartCard;
